<template>
  <div style="padding: 10px 5px">
    <div class="ecview">
      <div
        style="
          height: 50px;
          line-height: 25px;
          font-weight: 600;
          color: rgb(255, 255, 255);
          font-size: 14px;
          background-color: #01B198;
          text-align: center;
          display: flex;
          padding-left: 30px;
          box-sizing: border-box;
        "
        class="OneTie OneTieactive"
      >
        <div style="border-right: 1px solid rgba(0, 0, 0, 0.1); width: 20%">
          <div>Target/M</div>
          <div>Ach%</div>
        </div>
        <div style="border-right: 1px solid rgba(0, 0, 0, 0.1); width: 20%">
          <div>Daily</div>
          <div>Daily vs LY</div>
        </div>
        <div style="border-right: 1px solid rgba(0, 0, 0, 0.1); width: 20%">
          <div>MTD</div>
          <div>MTD vs LY</div>
        </div>
        <div style="border-right: 1px solid rgba(0, 0, 0, 0.1); width: 20%">
          <div>QTD</div>
          <div>QTD vs LY</div>
        </div>
        <div style="width: 20%">
          <div>YTD</div>
          <div>YTD vs LY</div>
        </div>
      </div>

      <div v-for="(item, i) in tableList" :key="i">
        <div
          style="
            display: flex;
            background: #B1E0DA;
            height: 80px;
            margin-bottom: 10px;
            border-radius: 10px;
            box-shadow: 0 5px 20px -10px #704f4f;
          "
        >
          <div @click="getList1(item, i)" style="width: 5%" class="redPlus">
            <img
              v-show="item.level1Flag"
              src="../../../assets/jpg/icon-1-down.svg"
              alt
            />
            <img
              v-show="!item.level1Flag"
              src="../../../assets/jpg/icon-1-right.svg"
              alt
            />
          </div>
          <div style="width: 95%; padding-right: 5px; box-sizing: border-box">
            <div style="line-height: 25px; font-size: 14px; font-weight: 600">
              {{ item.channel }}
            </div>
            <div style="display: flex">
              <div style="width: 20%; padding: 0 5px; box-sizing: border-box">
                <div style="border: 1px solid rgba(0, 0, 0, 0.1)">
                  <div style="height: 20px; line-height: 20px">
                    {{ Number(item.target).toFixed(0) | NumFormat }}
                  </div>
                  <div
                    :class="{ redColor: Number(item.ach * 100) < 0 }"
                    style="height: 20px; line-height: 20px"
                  >
                    {{ Number(item.ach * 100).toFixed(0) }}%
                  </div>
                </div>
              </div>
              <div style="width: 20%; padding: 0 5px; box-sizing: border-box">
                <div style="border: 1px solid rgba(0, 0, 0, 0.1)">
                  <div style="height: 20px; line-height: 20px">
                    {{ Number(item.daily).toFixed(0) | NumFormat }}
                  </div>
                  <div
                    :class="{ redColor: Number(item.daily_vs_LY * 100) < 0 }"
                    style="height: 20px; line-height: 20px"
                  >
                    {{ Number(item.daily_vs_LY * 100).toFixed(0) }}%
                  </div>
                </div>
              </div>
              <div style="width: 20%; padding: 0 5px; box-sizing: border-box">
                <div style="border: 1px solid rgba(0, 0, 0, 0.1)">
                  <div style="height: 20px; line-height: 20px">
                    {{ Number(item.MTD).toFixed(0) | NumFormat }}
                  </div>
                  <div
                    :class="{ redColor: Number(item.MTD_vs_LY * 100) < 0 }"
                    style="height: 20px; line-height: 20px"
                  >
                    {{ Number(item.MTD_vs_LY * 100).toFixed(0) }}%
                  </div>
                </div>
              </div>
              <div style="width: 20%; padding: 0 5px; box-sizing: border-box">
                <div style="border: 1px solid rgba(0, 0, 0, 0.1)">
                  <div style="height: 20px; line-height: 20px">
                    {{ Number(item.QTD).toFixed(0) | NumFormat }}
                  </div>
                  <div
                    :class="{ redColor: Number(item.QTD_vs_LY * 100) < 0 }"
                    style="height: 20px; line-height: 20px"
                  >
                    {{ Number(item.QTD_vs_LY * 100).toFixed(0) }}%
                  </div>
                </div>
              </div>
              <div style="width: 20%; padding: 0 5px; box-sizing: border-box">
                <div style="border: 1px solid rgba(0, 0, 0, 0.1)">
                  <div style="height: 20px; line-height: 20px">
                    {{ Number(item.YTD).toFixed(0) | NumFormat }}
                  </div>
                  <div
                    :class="{ redColor: Number(item.YTD_vs_LY * 100) < 0 }"
                    style="height: 20px; line-height: 20px"
                  >
                    {{ Number(item.YTD_vs_LY * 100).toFixed(0) }}%
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-show="item.level1Flag"
          v-for="(item1, i1) in item.level1List"
          :key="i1"
        >
          <div
            style="
              display: flex;
              background: #D3ECE685;
              height: 80px;
              margin-bottom: 10px;
              border-radius: 10px;
              box-shadow: 0 5px 20px -10px #704f4f;
            "
          >
            <div
              @click="getList2(item, item1, i, i1)"
              style="width: 5%"
              class="redPlus"
            >
              <img
                v-show="item1.level2Flag"
                src="../../../assets/jpg/icon-2-down.svg"
                alt
              />
              <img
                v-show="!item1.level2Flag"
                src="../../../assets/jpg/icon-2-right.svg"
                alt
              />
            </div>
            <div style="width: 95%; padding-right: 5px; box-sizing: border-box">
              <div style="line-height: 25px; font-size: 14px; font-weight: 600">
                {{ item1.brand }}
              </div>
              <div style="display: flex">
                <div style="width: 20%; padding: 0 5px; box-sizing: border-box">
                  <div style="border: 1px solid rgba(0, 0, 0, 0.1)">
                    <div style="height: 20px; line-height: 20px">
                      {{ Number(item1.target).toFixed(0) | NumFormat }}
                    </div>
                    <div
                      :class="{ redColor: Number(item1.ach * 100) < 0 }"
                      style="height: 20px; line-height: 20px"
                    >
                      {{ Number(item1.ach * 100).toFixed(0) }}%
                    </div>
                  </div>
                </div>
                <div style="width: 20%; padding: 0 5px; box-sizing: border-box">
                  <div style="border: 1px solid rgba(0, 0, 0, 0.1)">
                    <div style="height: 20px; line-height: 20px">
                      {{ Number(item1.daily).toFixed(0) | NumFormat }}
                    </div>
                    <div
                      :class="{ redColor: Number(item1.daily_vs_LY * 100) < 0 }"
                      style="height: 20px; line-height: 20px"
                    >
                      {{ Number(item1.daily_vs_LY * 100).toFixed(0) }}%
                    </div>
                  </div>
                </div>
                <div style="width: 20%; padding: 0 5px; box-sizing: border-box">
                  <div style="border: 1px solid rgba(0, 0, 0, 0.1)">
                    <div style="height: 20px; line-height: 20px">
                      {{ Number(item1.MTD).toFixed(0) | NumFormat }}
                    </div>
                    <div
                      :class="{ redColor: Number(item1.MTD_vs_LY * 100) < 0 }"
                      style="height: 20px; line-height: 20px"
                    >
                      {{ Number(item1.MTD_vs_LY * 100).toFixed(0) }}%
                    </div>
                  </div>
                </div>
                <div style="width: 20%; padding: 0 5px; box-sizing: border-box">
                  <div style="border: 1px solid rgba(0, 0, 0, 0.1)">
                    <div style="height: 20px; line-height: 20px">
                      {{ Number(item1.QTD).toFixed(0) | NumFormat }}
                    </div>
                    <div
                      :class="{ redColor: Number(item1.QTD_vs_LY * 100) < 0 }"
                      style="height: 20px; line-height: 20px"
                    >
                      {{ Number(item1.QTD_vs_LY * 100).toFixed(0) }}%
                    </div>
                  </div>
                </div>
                <div style="width: 20%; padding: 0 5px; box-sizing: border-box">
                  <div style="border: 1px solid rgba(0, 0, 0, 0.1)">
                    <div style="height: 20px; line-height: 20px">
                      {{ Number(item1.YTD).toFixed(0) | NumFormat }}
                    </div>
                    <div
                      :class="{ redColor: Number(item1.YTD_vs_LY * 100) < 0 }"
                      style="height: 20px; line-height: 20px"
                    >
                      {{ Number(item1.YTD_vs_LY * 100).toFixed(0) }}%
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            style="
              display: flex;
              height: 80px;
              margin-bottom: 10px;
              border-radius: 10px;
              box-shadow: 0 5px 20px -10px #704f4f;
            "
            v-show="item1.level2Flag"
            v-for="(item2, i2) in item1.level1List"
            :key="i2"
          >
            <div style="width: 5%" class="redPlus"></div>
            <div style="width: 95%; padding-right: 5px; box-sizing: border-box">
              <div style="line-height: 25px; font-size: 14px; font-weight: 600">
                {{ item2.store }}
              </div>
              <div style="display: flex">
                <div style="width: 20%; padding: 0 5px; box-sizing: border-box">
                  <div style="border: 1px solid rgba(0, 0, 0, 0.1)">
                    <div style="height: 20px; line-height: 20px">
                      {{ Number(item2.target).toFixed(0) | NumFormat }}
                    </div>
                    <div
                      :class="{ redColor: Number(item2.ach * 100) < 0 }"
                      style="height: 20px; line-height: 20px"
                    >
                      {{ Number(item2.ach * 100).toFixed(0) }}%
                    </div>
                  </div>
                </div>
                <div style="width: 20%; padding: 0 5px; box-sizing: border-box">
                  <div style="border: 1px solid rgba(0, 0, 0, 0.1)">
                    <div style="height: 20px; line-height: 20px">
                      {{ Number(item2.daily).toFixed(0) | NumFormat }}
                    </div>
                    <div
                      :class="{ redColor: Number(item2.daily_vs_LY * 100) < 0 }"
                      style="height: 20px; line-height: 20px"
                    >
                      {{ Number(item2.daily_vs_LY * 100).toFixed(0) }}%
                    </div>
                  </div>
                </div>
                <div style="width: 20%; padding: 0 5px; box-sizing: border-box">
                  <div style="border: 1px solid rgba(0, 0, 0, 0.1)">
                    <div style="height: 20px; line-height: 20px">
                      {{ Number(item2.MTD).toFixed(0) | NumFormat }}
                    </div>
                    <div
                      :class="{ redColor: Number(item2.MTD_vs_LY * 100) < 0 }"
                      style="height: 20px; line-height: 20px"
                    >
                      {{ Number(item2.MTD_vs_LY * 100).toFixed(0) }}%
                    </div>
                  </div>
                </div>
                <div style="width: 20%; padding: 0 5px; box-sizing: border-box">
                  <div style="border: 1px solid rgba(0, 0, 0, 0.1)">
                    <div style="height: 20px; line-height: 20px">
                      {{ Number(item2.QTD).toFixed(0) | NumFormat }}
                    </div>
                    <div
                      :class="{ redColor: Number(item2.QTD_vs_LY * 100) < 0 }"
                      style="height: 20px; line-height: 20px"
                    >
                      {{ Number(item2.QTD_vs_LY * 100).toFixed(0) }}%
                    </div>
                  </div>
                </div>
                <div style="width: 20%; padding: 0 5px; box-sizing: border-box">
                  <div style="border: 1px solid rgba(0, 0, 0, 0.1)">
                    <div style="height: 20px; line-height: 20px">
                      {{ Number(item2.YTD).toFixed(0) | NumFormat }}
                    </div>
                    <div
                      :class="{ redColor: Number(item2.YTD_vs_LY * 100) < 0 }"
                      style="height: 20px; line-height: 20px"
                    >
                      {{ Number(item2.YTD_vs_LY * 100).toFixed(0) }}%
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 渲染brand 趋势图 -->
      <div
        :class="brandNIn === 0 ? 'pos_Tmall first' : 'pos_Tmall'"
        v-for="(brandV, brandN, brandNIn) in brandAllData"
        :key="brandN"
      >
        <div class="Tmall_nav">
          <p>{{ brandN }}</p>
        </div>
        <template v-for="(brandNChild, brandCIChild) in brandAllData[brandN]">
          <barStackChartsBsic
            :key="brandCIChild"
            :chartData="brandNChild.chartData"
            :chartTitle="brandNChild.childName"
          />
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import qs from "qs";
import "echarts/map/js/china.js";
import Mymap from "@/components/ButSecoend/Public/Map";
import barStackChartsBsic from "./SumTableDrawChart.vue";
// import dataJson from "./sumTable.js";
export default {
  data() {
    return {
      brandAllData: {},
      type1: "",
      type2: "",
      type3: "",
      type4: "",
      type5: "",

      typeValue: {},

      isShow: true,
      isShow2: false,
      tableList: [
        {
          daily: "",
          daily_vs_LY: "",
          MTD: "",
          MTD_vs_LY: "",
          QTD: "",
          QTD_vs_LY: "",
          YTD: "",
          YTD_vs_LY: "",
          ach: "",
          channel: "",
          target: "",
          level1Flag: false,
          level1List: [
            {
              daily: "",
              daily_vs_LY: "",
              MTD: "",
              MTD_vs_LY: "",
              QTD: "",
              QTD_vs_LY: "",
              YTD: "",
              YTD_vs_LY: "",
              ach: "",
              brand: "",
              target: "",
              level2Flag: false,
              level1List: [
                {
                  daily: "",
                  daily_vs_LY: "",
                  MTD: "",
                  MTD_vs_LY: "",
                  QTD: "",
                  QTD_vs_LY: "",
                  YTD: "",
                  YTD_vs_LY: "",
                  ach: "",
                  store: "",
                  target: ""
                }
              ]
            }
          ]
        }
      ],
      MapList: [],
      MapData: [],
      isBtn: true,
      isBtn2: true,
      achVing: sessionStorage.getItem("achVing"),
      showDate: false,
      brand1: false,
      brand2: false,
      brand3: false,
      brand4: false,
      channel3: false,
      type: "",

      weekPatternFlag: false
    };
  },
  methods: {
    dealNum(value) {
      if (!value) return "0";
      var intPart = Number(value).toFixed(0); // 获取整数部分
      var intPartFormat = intPart
        .toString()
        .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,"); // 将整数部分逢三一断
      return intPartFormat;
    },
    getLabelName(jiancheng) {
      const objName = {
        day: "Daily vs LY GR%",
        month: "MTD vs Last GR%",
        year: "YTD vs Last GR%"
      };
      return objName[jiancheng] || "";
    },
    async getECDataList() {
      const res = await this.$addr.get("ECDashboard/getECDataList");
      // const dataAll = dataJson;
      if (res.data.error !== 0) {
        return;
      }
      const dataAll = res.data.data;
      console.log(dataAll, "4448-----");

      let backData = {};
      Object.keys(dataAll).forEach(item => {
        backData[item] = [];
        Object.keys(dataAll[item]).forEach(itemChild => {
          const currentChartData = dataAll[item][itemChild]["chartData"];
          const currentGrData = dataAll[item][itemChild]["gr"];
          const grDateData =
            currentGrData["grDate"] ||
            Array.from({ length: 31 }).map((item, index) => index + 1 + "");
          let dyCoums = [];
          const maxLength = 0;
          const initTableGrData = [];
          Object.keys(currentGrData).forEach(kk => {
            if (kk !== "grDate") {
              const initTObj = {
                category: this.getLabelName(kk)
              };
              currentGrData[kk].map((grArr, grArrIndex) => {               
                initTObj[grDateData[grArrIndex]] =
                  grArr || grArr === 0
                    ? `${Number(grArr * 100).toFixed(2)}%`
                    : grArr;
              });
              initTableGrData.push(initTObj);
            }
            // if (
            //   currentGrData[kk].length &&
            //   currentGrData[kk].length > maxLength
            // ) {
            //   dyCoums = currentGrData[kk];
            // }
          });
          dyCoums = grDateData
            ? grDateData.map((date, jjIndex) => {
                return {
                  label: date,
                  prop: date,
                  width: "72px"
                };
              })
            : [];
          backData[item].push({
            childName: itemChild,
            chartData: {
              xData: currentChartData.map(ii => {
                return ii.date;
              }),
              seriesData: [
                currentChartData.map(ii => {
                  return ii.GMV.toFixed(0);
                }),
                currentChartData.map(ii => {
                  return ii.LY_GMV.toFixed(0);
                })
              ],
              totalDuibi: {
                tableData: initTableGrData,
                tableColumn: [
                  {
                    label: "category",
                    prop: "category",
                    fixed: true,
                    width: "70px"
                  },
                  ...dyCoums
                ]
              }
            }
          });
        });
      });
      console.log(backData, "505-----");
      this.brandAllData = backData;
    },
    getWidthPercent(value) {
      if ((value * 100).toFixed(1) >= 100) {
        return "97%";
      } else {
        return (value * 100).toFixed(1) + "%";
      }
    },

    getDataClass(a, b, c) {
      if (b !== 0) {
        if (a / b > 1) {
          return "helthy"; //绿色
        } else if (a / b < 0.8) {
          return "notice"; //红色
        } else {
          return "pin"; //黄色
        }
      } else {
        if (a / c > 1) {
          return "helthy"; //绿色
        } else if (a / c < 0.8) {
          return "notice"; //红色
        } else {
          return "pin"; //黄色
        }
      }
    },

    getDataClassTitle(a, b, c) {
      if (b !== 0) {
        if (a / b > 1) {
          return "helthyFormat"; //绿色
        } else if (a / b < 0.8) {
          return "noticeFormat"; //红色
        } else {
          return "pinFormat"; //黄色
        }
      } else {
        if (a / c > 1) {
          return "helthyFormat"; //绿色
        } else if (a / c < 0.8) {
          return "noticeFormat"; //红色
        } else {
          return "pinFormat"; //黄色
        }
      }
    },

    changeBrand(e) {
      if (
        $(e.currentTarget)
          .parent()
          .parent()
          .find(".redPlus")
          .attr("class") == "redPlus"
      ) {
        $(e.currentTarget)
          .parent()
          .parent()
          .find(".redPlus")
          .addClass("redPlusActiveImg");
      } else {
        $(e.currentTarget)
          .parent()
          .parent()
          .find(".redPlus")
          .removeClass("redPlusActiveImg");
      }
      if (
        $(e.currentTarget)
          .parent()
          .parent()
          .find(".redPlus")
          .attr("class") == "redPlus redPlusActiveImg redPlusActive"
      ) {
        $(e.currentTarget)
          .parent()
          .parent()
          .find(".redPlus")
          .removeClass("redPlusActiveImg");
      } else {
        $(e.currentTarget)
          .parent()
          .parent()
          .find(".redPlus")
          .addClass("redPlusActiveImg");
      }
      $(e.currentTarget)
        .parent()
        .parent()
        .nextAll(".BrandOneTie")
        .stop()
        .slideToggle(500);
      $(e.currentTarget)
        .parent()
        .parent()
        .nextAll(".ChannelList1")
        .css("display", "none");
    },
    changeBrandTwo(e) {
      if ($(e.currentTarget).attr("class") == "red redActive") {
        $(e.currentTarget).removeClass("redActive");
      } else {
        $(e.currentTarget).addClass("redActive");
      }
      if (
        $(e.currentTarget)
          .parent()
          .parent()
          .find(".redPlus")
          .attr("class") == "redPlus redPlusActive"
      ) {
        $(e.currentTarget)
          .parent()
          .parent()
          .find(".redPlus")
          .removeClass("redPlusActive");
      }
      $(e.currentTarget)
        .parent()
        .parent()
        .nextAll(".BrandTieTie")
        .stop()
        .slideToggle(500);
      $(e.currentTarget)
        .parent()
        .parent()
        .nextAll(".TwoTieAct")
        .css("display", "none");
    },
    changeBrandThr(e) {
      console.log(
        $(e.currentTarget)
          .parent()
          .parent()
      );
      if (
        $(e.currentTarget)
          .parent()
          .parent()
          .find(".redPlus")
          .attr("class") == "redPlus redPlusActive"
      ) {
        $(e.currentTarget)
          .parent()
          .parent()
          .find(".redPlus")
          .removeClass("redPlusActive");
      }
      if ($(e.currentTarget).attr("class") == "red redActive") {
        $(e.currentTarget).removeClass("redActive");
      } else {
        $(e.currentTarget).addClass("redActive");
      }

      $(e.currentTarget)
        .parent()
        .parent()
        .nextAll(".BrandThrTie")
        .stop()
        .slideToggle(500);
      $(e.currentTarget)
        .parent()
        .parent()
        .nextAll(".channelThr")
        .css("display", "none");
    },
    changeBrandFor(e) {
      $(e.currentTarget)
        .parent()
        .parent()
        .nextAll(".BrandForTie")
        .stop()
        .slideToggle(500);

      if ($(e.currentTarget).attr("class") == "red redActive") {
        $(e.currentTarget).removeClass("redActive");
      } else {
        $(e.currentTarget).addClass("redActive");
      }
    },
    changeChannel(e) {
      if (
        $(e.currentTarget)
          .find(".red")
          .attr("class") == "red redActive"
      ) {
        $(e.currentTarget)
          .find(".red")
          .removeClass("redActive");
      }
      if (
        $(e.currentTarget)
          .find(".redPlus")
          .attr("class") == "redPlus redPlusActive"
      ) {
        $(e.currentTarget)
          .find(".redPlus")
          .removeClass("redPlusActive");
      } else {
        $(e.currentTarget)
          .find(".redPlus")
          .addClass("redPlusActive");
      }
      $(e.currentTarget)
        .nextAll(".TwoTieAct")
        .stop()
        .slideToggle(500);
      $(e.currentTarget)
        .nextAll(".BrandOneTie")
        .css("display", "none");
    },
    changeChannelTwo(e) {
      if (
        $(e.currentTarget)
          .find(".red")
          .attr("class") == "red redActive"
      ) {
        $(e.currentTarget)
          .find(".red")
          .removeClass("redActive");
      }
      $(e.currentTarget)
        .parent()
        .parent()
        .nextAll(".TwoTieAct")
        .stop()
        .slideToggle(500);
      $(e.currentTarget)
        .nextAll(".BrandTieTie")
        .css("display", "none");
    },
    changeChannelThr(e) {
      if (
        $(e.currentTarget)
          .find(".red")
          .attr("class") == "red redActive"
      ) {
        $(e.currentTarget)
          .find(".red")
          .removeClass("redActive");
      }
      if (
        $(e.currentTarget)
          .find(".redPlus")
          .attr("class") == "redPlus redPlusActive"
      ) {
        $(e.currentTarget)
          .find(".redPlus")
          .removeClass("redPlusActive");
      } else {
        $(e.currentTarget)
          .find(".redPlus")
          .addClass("redPlusActive");
      }
      $(e.currentTarget)
        .nextAll(".channelThr")
        .stop()
        .slideToggle(500);

      $(e.currentTarget)
        .nextAll(".BrandThrTie")
        .css("display", "none");
    },
    showUpdata() {
      this.showDate = !this.showDate;
    },
    getList() {
      this.tableList = [];
      this.$addr
        // .get("http://10.216.226.81:8080/mobile_api/sellin/getChannelByList")
        // .get("sellin/getChannelByList")
        .get("ECDashboard/getLevel1List")
        .then(res => {
          res.data.data.forEach(item => {
            let obj = {
              daily: item.daily,
              daily_vs_LY: item.daily_vs_LY,
              MTD: item.MTD,
              MTD_vs_LY: item.MTD_vs_LY,
              QTD: item.QTD,
              QTD_vs_LY: item.QTD_vs_LY,
              YTD: item.YTD,
              YTD_vs_LY: item.YTD_vs_LY,
              ach: item.ach,
              channel: item.channel,
              target: item.target,
              level1Flag: false,
              level1List: [
                {
                  daily: "",
                  daily_vs_LY: "",
                  MTD: "",
                  MTD_vs_LY: "",
                  QTD: "",
                  QTD_vs_LY: "",
                  YTD: "",
                  YTD_vs_LY: "",
                  ach: "",
                  brand: "",
                  target: "",
                  level2Flag: false,
                  level1List: [
                    {
                      daily: "",
                      daily_vs_LY: "",
                      MTD: "",
                      MTD_vs_LY: "",
                      QTD: "",
                      QTD_vs_LY: "",
                      YTD: "",
                      YTD_vs_LY: "",
                      ach: "",
                      store: "",
                      target: ""
                    }
                  ]
                }
              ]
            };
            this.tableList.push(obj);
          });
          console.log(this.tableList);
        })
        .catch(error => {
          this.$toast("接受数据失败");
        });
    },
    getList1(item, index) {
      this.tableList[index].level1Flag = !this.tableList[index].level1Flag;
      this.tableList[index].level1List = [];
      let itemList = item;
      let that = this;
      if (this.tableList[index].level1Flag) {
        this.$addr
          .get("ECDashboard/getLevel2List?channel=" + itemList.channel)
          .then(res => {
            res.data.data.forEach(item => {
              let obj = {
                daily: item.daily,
                daily_vs_LY: item.daily_vs_LY,
                MTD: item.MTD,
                MTD_vs_LY: item.MTD_vs_LY,
                QTD: item.QTD,
                QTD_vs_LY: item.QTD_vs_LY,
                YTD: item.YTD,
                YTD_vs_LY: item.YTD_vs_LY,
                ach: item.ach,
                brand: item.brand,
                target: item.target,
                level2Flag: false,
                level1List: [
                  {
                    daily: "",
                    daily_vs_LY: "",
                    MTD: "",
                    MTD_vs_LY: "",
                    QTD: "",
                    QTD_vs_LY: "",
                    YTD: "",
                    YTD_vs_LY: "",
                    ach: "",
                    store: "",
                    target: ""
                  }
                ]
              };
              that.tableList[index].level1List.push(obj);
              // this.tableList.push(obj);
            });
          })
          .catch(error => {
            this.$toast("接受数据失败");
          });
      }
    },
    getList2(item, item1, index, index1) {
      this.tableList[index].level1List[index1].level2Flag = !this.tableList[
        index
      ].level1List[index1].level2Flag;
      this.tableList[index].level1List[index1].level1List = [];
      let itemList = item;
      let itemList1 = item1;
      let that = this;
      if (this.tableList[index].level1List[index1].level2Flag) {
        this.$addr
          .get(
            "ECDashboard/getLevel3List?channel=" +
              itemList.channel +
              "&brand=" +
              itemList1.brand
          )
          .then(res => {
            res.data.data.forEach(item => {
              let obj = {
                daily: item.daily,
                daily_vs_LY: item.daily_vs_LY,
                MTD: item.MTD,
                MTD_vs_LY: item.MTD_vs_LY,
                QTD: item.QTD,
                QTD_vs_LY: item.QTD_vs_LY,
                YTD: item.YTD,
                YTD_vs_LY: item.YTD_vs_LY,
                ach: item.ach,
                store: item.store,
                target: item.target
              };
              that.tableList[index].level1List[index1].level1List.push(obj);
              // this.tableList.push(obj);
            });
          })
          .catch(error => {
            this.$toast("接受数据失败");
          });
      }
    },
    getType() {
      this.$addr
        // .post("/getSalesData", qs.stringify({ brandCd: this.brandName }))
        // .get("http://10.216.226.81:8080/mobile_api/sellin/getBuByList")
        // .get("sellin/getTargetType")
        .get("sellinAndsellout/getTargetTypeSellinAndSellout")
        .then(res => {
          if (res.data.error == 0) {
            let resultData = res.data.data[0];
            this.type1 = resultData.SELLOUT_TARGETTYPE1;
            this.type2 = resultData.SELLOUT_TARGETTYPE2;

            this.type3 = resultData.SELLOUT_TARGETTYPE_BTG1;
            this.type4 = resultData.SELLOUT_TARGETTYPE_BTG2;
          }
        })
        .catch(error => {
          this.$toast("接受数据失败");
        });
    },

    getTypeData() {
      this.$addr
        .get("sellinAndsellout/getSumDataSellinAndSellout")
        .then(res => {
          if (res.data.error == 0) {
            this.typeValue = res.data.data[0];

            if (this.typeValue.weekPattern) {
              // Weekly Pattern
              this.weekPatternFlag = true;
              this.type5 = "pattern";
            } else {
              // Time Gone
              this.weekPatternFlag = false;
              this.type5 = "Time Gone";
            }
          }
        })
        .catch(error => {
          this.$toast("接受数据失败");
        });
    },

    changeImg(e) {
      if (
        $(e.currentTarget)
          .find(".red")
          .attr("class") == "red redActive"
      ) {
        $(e.currentTarget)
          .find(".red")
          .removeClass("redActive");
      }
      if (
        $(e.currentTarget)
          .find(".redPlus")
          .attr("class") == "redPlus redPlusActiveImg"
      ) {
        $(e.currentTarget)
          .find(".redPlus")
          .removeClass("redPlusActiveImg");
      } else {
        $(e.currentTarget)
          .find(".redPlus")
          .addClass("redPlusActiveImg");
      }
      $(e.currentTarget)
        .nextAll(".ChannelList1")
        .stop()
        .slideToggle(500);
      $(e.currentTarget)
        .nextAll(".BrandOneTie")
        .css("display", "none");
    }
  },
  created() {
    this.getList();
  },
  mounted() {
    this.getECDataList();
  },
  components: {
    Mymap,
    barStackChartsBsic
  }
};
</script>
<style scoped>
.redColor {
  color: rgb(176, 93, 91);
}
.Pos_main .all_nav,
.Pos_main .Tmall_nav,
.Pos_main .stage_nav {
  background: #f6f6ff;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.5);
  border-radius: 20px;
  background: #01B198;
  border-radius: 22.5008px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.Tmall_nav {
  width: calc(100% - 28px);
  margin: 0 14px;
}
.Tmall_nav p {
  display: flex;
}
.Tmall_nav p > span:first-child {
  align-self: center;
}
.Tmall_nav_describe {
  font-size: 10px;
  font-family: MicrosoftYaHei;
  color: #d1a0a0;
  padding-left: 0px;
  padding-right: 10px;
  line-height: 16px;
  transform: scale(0.94);
  align-self: center;
}
.ecview > .pos_Tmall {
  padding-top: 6px;
}
.ecview > .first {
  padding-top: 2px;
}
.Pos_main .all_nav p,
.Tmall_nav p,
.stage_nav p {
  margin-left: 15px;
  font-family: "微软雅黑" !important;
  font-size: 16px;
  color: #ffffff;
}
.clickInfo {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 10px;
}

.proBoxsLeft {
  display: flex;
  justify-content: left;
  align-items: center;
  /* margin-top: 10px; */
}

.proBoxsRight {
  display: flex;
  justify-content: right;
  align-items: center;
  margin-right: 8px;
  /* margin-top: 10px; */
}
.clickInfo p {
  color: #424242;
  letter-spacing: 0;
  text-align: center;
  font-family: "微软雅黑" !important;
  font-size: 10px;
}
.showDate {
  padding: 20px;
  font-family: "微软雅黑" !important;
  font-size: 10px;
  color: #191919;
  border: 1px solid black;
  z-index: 999999999999999;
  position: absolute;
  top: 30px;
  background: #fcfcfc;
  border-radius: 15px;
  min-height: 20px;
  width: 90%;
}

ul li {
  margin-bottom: 2px;
  font-size: 10px;
  color: #191919;
  width: 100%;
  height: 20px;
  /* 强制不换行 */
  text-overflow: ellipsis;
  border-bottom: 1px solid rgba(157, 157, 157, 0.4);
  line-height: 20px;
}
.SelTop {
  position: relative;
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.SelTop .sel_right {
  position: relative;
  /* display: flex;
  align-items: center;
  justify-content: space-between; */
  width: 450px;
  height: 21px;
  background: rgba(152, 152, 152, 0.5);
  box-shadow: inset 0 0 5px 0 #9e9e9e;
  border-radius: 42.5px;
  margin-left: 10px;
  margin-bottom: 10px;
}

.SelTop .sel_right p {
  float: left;
  font-family: "微软雅黑" !important;
  font-size: 10px;
  line-height: 21px;
  color: #f9f9f9;
  padding-left: 13px;
}

.progressBox {
  width: 86%;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 5px -1px rgba(90, 66, 37, 0.5);
  padding: 5px 6px;
  box-sizing: border-box;
  /* padding: 5px 8px; */
}

.SelTop .sel_right b {
  float: right;
  margin-right: 5px;
  margin-top: 5px;
  text-align: center;
  line-height: 12px;
  font-size: 10px;
  background: #f9f9f9;
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.red {
  font-size: 16px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  height: 100%;
  transform: scaleX(-1);
  box-shadow: 0 0 5px -1px rgba(90, 66, 37, 0.5);
  border-radius: 10px 0px 0px 10px;
}
.redActive {
  display: flex;
  align-items: center;
  padding: 0 10px;
  transform: scaleX(-1);
  box-shadow: inset 0 0 5px 0 rgba(59, 59, 59, 0.5);
  border-radius: 10px 0px 0px 10px;
}
.red img {
  width: 17px;
  height: 17px;
}
.redPlus {
  display: flex;
  align-items: center;
  height: 100%;
  margin: 0 6px;
}
.redPlus img {
  width: 24px;
  height: 24px;
}
.redPlusActive > img {
  transform: rotate(90deg);
}
.redPlusActiveImg > img {
  transform: rotate(-90deg);
}
.LittleBut {
  height: 20px;
  width: 20px;
  text-align: center;
  background: rgba(158, 131, 108, 0.3);
  border-radius: 50%;
  line-height: 20px;
}
.notice {
  background: #c7544d !important;
}

.title {
  font-weight: 700;
  margin: 10px 0px 8px 0px;
  display: flex;
  justify-content: left;
}

.noticeCol {
  background: #f9c6bd !important;
}
.noticeFormat {
  color: #c7544d !important;
}
.helthyFormat {
  color: #84a05f !important;
}

.pinFormat {
  color: #e9c978 !important;
}
.pinCol {
  background: #f3d480 !important;
}
.helthyCol {
  background: #d4e1b4 !important;
}
.helthy {
  background: #84a05f !important;
}
.pin {
  background: #f3d480 !important;
}
.list {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.list b {
  text-align: right;
  min-width: 50px;
  font-family: "微软雅黑" !important;
  height: 37px;
  line-height: 37px;
  font-size: 15px;
  color: #3a3a3b;
}
.list span {
  text-align: left;
  font-family: "微软雅黑" !important;
  height: 37px;
  min-width: 50px;
  line-height: 37px;
  font-size: 15px;
  color: #3a3a3b;
}
.tableLeft {
  /* padding: 12px 5px 13px 22px; */
  /* padding: 10px 5px; */
  display: flex;
  justify-content: left;
  align-items: center;
  flex-direction: column;
  /* min-height: 45px; */
}
.tableLeft .tableTop {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tableLeft .tableTop span {
  font-family: "微软雅黑" !important;
  font-size: 12px;
  color: #3a3a3b;
  white-space: nowrap;
}

.tableLeft .tabMid {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}
.tableLeft .tabMid b {
  /* margin-top: 4px; */
  min-width: 100%;
  text-align: left;
  font-family: "微软雅黑" !important;
  font-size: 16px;
}

.tableRight .tabMid b {
  margin-top: 4px;
  min-width: 100%;
  text-align: left;
  font-family: "微软雅黑" !important;
  font-size: 16px;
}

.TwoTie .progress {
  width: 95.2%;
}
.TwoTie .tableLeft .tableTop span {
  overflow: hidden;
  white-space: nowrap;
}
.progress {
  /* margin-top: 6px;
  margin-bottom: 6px; */
  /* margin: 6px 0px; */
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.textTitle {
  font-size: 8px;
  white-space: nowrap;
  text-align: left;
  margin: 4px 0;
}
.progress span {
  width: 100%;
  display: block;
  background: #dddde9;
  border-radius: 5px;
  height: 12px;
}

.progress label {
  font-size: 6px;
  white-space: nowrap;
  margin: 2px;
}

.progress span p {
  display: block;
  font-family: "微软雅黑" !important;
  font-size: 10px;
  color: #f6f6ff;
  line-height: 14px;
  border-radius: 5px;
  text-align: right;
  /* padding-right: 6px; */
}
.vsProgress span {
  width: 100%;
  display: block;
  background: #dddde9;
  border-radius: 5px;
  height: 14px;
  line-height: 20px;
  box-sizing: border-box;

  margin-top: 3px;
}
.vsProgress span p {
  display: block;
  width: 50%;
  font-family: "微软雅黑" !important;
  font-size: 10px;
  color: #4f4779;
  line-height: 14px;
  border-radius: 5px;
  text-align: right;
  padding-right: 6px;
}
.tableLeft span {
  font-family: "微软雅黑" !important;
  font-size: 12px;
  font-weight: 600;
  color: #4f4779;
}
.tableLeft b {
  font-family: "微软雅黑" !important;
  font-size: 15px;
  color: #84a05f;
}
.tableRight {
  padding: auto 4px;
  /* margin-top: 12px; */
  /* width: 100%; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.tableLeft .leftFlex {
  padding-left: 8px;
  position: relative;
  margin-bottom: 1px;
  width: 100%;
  display: flex;
  justify-content: left;
  line-height: 20px;
}

.tableCenter {
  /* padding: 4px; */
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.tableCenter .centerFlex {
  position: relative;
  margin-bottom: 1px;
  width: 100%;
  display: flex;
  color: #3a3a3b;
  justify-content: center;
  line-height: 20px;
  font-size: 10px;
  white-space: nowrap;
  overflow: hidden;
}

.tableRight .rightFlex {
  padding-right: 8px;
  position: relative;
  margin-bottom: 1px;
  width: 100%;
  line-height: 20px;
  display: flex;
  justify-content: right;
}
.tableRight .rightFlex span {
  /* min-width: 60px; */
  font-family: "微软雅黑" !important;
  font-size: 12px;
  font-weight: 600;
  color: #4f4779;
  text-align: right;
  display: flex;
  justify-content: end;
}
.tableRight .rightFlex b {
  text-align: right;
  min-width: 50px;
  font-family: "微软雅黑" !important;
  font-size: 10px;
  color: #332a66;
}
.tableRight .rightFlex i {
  font-style: normal;
  text-align: left;
  min-width: 60px;
  font-family: "微软雅黑" !important;
  font-size: 11px;
  color: #3a3a3b;
}
.tableRight .rightFlex img {
  position: absolute;
  width: 12px;
  height: 12px;
  left: 8px;
  top: -3px;
}
.box {
  margin: 1.5px auto 0;
  padding: 0 7px;
  position: relative;
}
.OneTie {
  position: relative;

  /* margin-left: 5px; */
  width: 97%;
  /* height: 144px; */
  height: 100px;
  background: #ffffff;
  box-shadow: 0 5px 20px -10px #704f4f;
  border-radius: 10px;
  /* line-height: 20px; */
  /* text-align: right;
  text-align: center; */

  font-family: "微软雅黑" !important;

  font-size: 12px;
  color: #000000;
  margin-bottom: 10px;
  z-index: 999;
}
.OneTieactive {
  width: 100%;
  /* margin-left: -9px; */
  background: #f2dec6;
  box-shadow: 0 5px 20px -10px #704f4f;
  border-radius: 10px;
  font-size: 12px;
}
.TwoTieactive {
  background: #faf1e7;
}
.TwoTieAct {
  background: #ffffff;
  margin-bottom: 8px;
  width: 96%;
  border-radius: 10px;
  margin-left: 7px;
}
.ly {
  margin-left: 10px;
  display: inline-block;
  width: 40px;
  height: 12px;
  line-height: 12px;
  text-align: center !important;
  border-radius: 6px;
  background: #d4e1b4;
}
.TwoTie {
  text-align: center;
  border-radius: 10px;
  font-family: "微软雅黑" !important;
  font-size: 11px;
  color: #191919;

  height: 100px;
  /* line-height: 20px; */
  z-index: 999;
  box-shadow: 0 5px 20px -10px #704f4f;
}

.middleContentCenter {
  margin-top: -5px;
}

.BrandThrTie,
.BrandForTie {
  border-bottom: 2px solid rgba(157, 157, 157, 0.4);
  text-align: center;
  font-family: "微软雅黑" !important;
  font-size: 11px;
  color: #191919;
  /* height: 144px; */

  height: 100px;
  /* line-height: 20px; */
  z-index: 999;
}

.channelThr {
  /* height: 130px; */
}
</style>



// WEBPACK FOOTER //
// src/components/ButSecoend/Ecview/SumTable.vue